/**
 * 스탬프(빈도) 관련 공용 GraphQL 문서.
 * home, first-visit-bottom-sheet 등에서 재사용하므로 src/api에 둠.
 */
import { gql } from "@apollo/client";

export const FREQUENCY_COUNT_QUERY = gql`
  query FrequencyCount {
    me {
      frequencyCount
    }
  }
`;
